document.addEventListener('alpine:init', () => {
  Alpine.data('addonData', ({ defaultChecked, values }) => ({
    checked: defaultChecked,
    optionValues: values,
    modalOpen: false,

    init() {
      this.$el.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);

        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });
    },

    // updateSelectionMetadata(event) {
    //   const el = this.getInputForEventTarget(event.target);

    //   if (el?.matches?.('input[type="radio"]')) {
    //     const group = this.$el.querySelectorAll(`input[name="${el.name}"]`);
    //     group.forEach((input) => input.toggleAttribute('checked', input.checked));
    //   }
    // },

    getInputForEventTarget(target) {
      return target;
    },

    get selectedOptionValues() {
      const nodes = this.$el.parentNode.querySelectorAll(`input[type="radio"]:checked`);
      return Array.from(nodes).map((el) => el.value);
    },

    handleChecked() {
      // this.checked = this.checked === this.optionValues[1] ? this.optionValues[0] : this.optionValues[1];
      this.checked = this.checked === this.optionValues[0] ? this.optionValues[1] : this.optionValues[0];

      this.$el.closest(".product-addon").querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = input.value === this.checked ? true : false;
      });

      const input = this.$el.closest(".product-addon").querySelector(`input[type="radio"][value="${this.checked}"]`);
      if (input) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },

    isChecked() {
      // return this.checked === this.optionValues[1]
      return this.checked === this.optionValues[0]
    },

    handleModalOpen(state = null) {
      this.modalOpen = state !== null ? state : !this.modalOpen;
    }
  }));
});